import type { FC, PropsWithChildren } from 'react';
import React, { createContext, useContext, useLayoutEffect } from 'react';

import { useInstance } from '../hooks';
import { OverlayItemModel } from './OverlayItemModel';
import { OverlayManager } from './OverlayManager';
import type { IParentModel, OverlayOptions } from './types';

interface OverlayTreeItemProps extends OverlayOptions {
    /**
     * Видимость слоя
     */
    visible: boolean;

    /**
     * Для дебага
     */
    overlayTreeItemName?: string;
}

const PopupTreeContext = createContext<IParentModel | undefined>(undefined);

export const OverlayTreeItem: FC<PropsWithChildren<OverlayTreeItemProps>> = ({
    children,
    visible,
    essentialRefs,
    checkLastCloses = false,
    closeStrategy,
    onClose,
    overlayTreeItemName,
}) => {
    const parentModel = useContext(PopupTreeContext);
    const model = useInstance(OverlayItemModel, parentModel, overlayTreeItemName);

    useLayoutEffect(() => {
        model.updateParams({
            onClose,
            essentialRefs,
            closeStrategy,
            checkLastCloses,
        });
    });

    useLayoutEffect(() => {
        const manager = OverlayManager.getInstance();

        if (visible) {
            manager.addOverlay(model);
        }

        model.updateVisible(visible);

        return () => {
            manager.removeOverlay(model);
            model.updateVisible(false);
        };
    }, [visible, model]);

    return <PopupTreeContext.Provider value={model}>{children}</PopupTreeContext.Provider>;
};
